<template>
    <div class="panel-body">
        <div class="row">
            <div class="form-inline">
                <div class="form-group">
                    <select id="course-select" class="form-control select2" v-model="selectedCourse">
                        <option value="" selected>-- Show Current PBs --</option>
                        <option value="L">Long Course</option>
                        <option value="S">Short Course</option>
                    </select>
                </div>
                <div class="form-group">
                    <select id="event-select" class="form-control select2" v-model="selectedEvent">
                        <option value="" selected>-- Show Current PBs --</option>
                        <option v-for="(event, code) in events" :value="code">{{ event }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <button v-on:click="updateResults()" class="btn btn-success">Update Results</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12" style="height: 400px;">
                <iframe id="rankingsPBs"
                        title="Individual Best Times"
                        scrolling="yes"
                        frameborder="0"
                        style="position: relative; height: 100%; width: 100%;"
                        src="https://swimmingresults.org/">
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import { Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);

    export default {
        props: {
            event_code: {
                type: String,
                default: null
            },
            membershipNumber: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                selectedCourse: null,
                selectedEvent: null,
                text: '',
                checkResults: null,
                events: {
                    1: '50m Freestyle',
                    2: '100m Freestyle',
                    3: '200m Freestyle',
                    4: '400m Freestyle',
                    5: '800m Freestyle',
                    6: '1500m Freestyle',
                    7: '50m Breaststroke',
                    8: '100m Breaststroke',
                    9: '200m Breaststroke',
                    10: '50m Butterfly',
                    11: '100m Butterfly',
                    12: '200m Butterfly',
                    13: '50m Backstroke',
                    14: '100m Backstroke',
                    15: '200m Backstroke',
                    16: '200m Individual Medley',
                    17: '400m Individual Medley',
                    18: '100m Individual Medley'
                }
            }
        },
        computed: {
            rankingsUrl: function() {
                if (this.selectedEvent && this.selectedCourse && this.selectedEvent.length > 0 && this.selectedCourse.length > 0) {
                    return 'https://swimmingresults.org/individualbest/personal_best_time_date.php?back=individualbest&tiref=' + this.membershipNumber+ '&mode=A&tstroke=' + this.selectedEvent+ '&tcourse=' + this.selectedCourse;
                }
                return 'https://swimmingresults.org/individualbest/personal_best.php?mode=A&tiref=' + this.membershipNumber;
            }
        },
        mounted() {
            this.debug('Registered Members Validate component mounted.');
        },
        methods: {
            checkData(text) {
                this.text = text;
            },
            setCheckResult(data) {
                this.checkResults = data;
            },
            debug(message) {
                console.log('TrainingSetList: ' + message);
            },
            updateResults() {
                console.log('updateResults');
                console.log(this.rankingsUrl);

                const options = {
                    headers: {
                        'Pragma': 'no-cache',
                        'Cache-Control': 'no-cache'
                    }
                };

                axios.get(this.rankingsUrl, options).then((response) => {
                    // this.loadingInstance.close();

                    console.log(response.data);
                    console.log(response.status);
                    console.log(response.statusText);
                    console.log(response.headers);
                    console.log(response.config);

                    this.debug(response.data);
                }).catch((error) => {
                    // this.loadingInstance.close();
                    if (error.response) {
                        console.log('The request was made and the server responded with a status code');
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log('The request was made but no response was received');
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        console.log('Something happened in setting up the request that triggered an Error');
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                    this.$message({message: 'There was a problem loading the results page.', type: 'error'});
                });
            }
        }
    }
</script>